import {
  validation_succcess_border_color,
  validation_failed_border_color,
} from "../consts/colors";
import { error_messages, response_error_messages } from "../consts/messages";
import {
  catch_error,
  is_password_validated,
  update_password,
} from "./functions";
import { loadFirebaseAuth } from "./firebase";
import { email_regex } from "../consts/regex";
import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";

var update_confirm_password_validated = false;
var update_password_validated = false;
var password_validation_id = "password_update_submit";
var password = "";
var password_confirm = "";

var auth_email_validated = false;
var auth_password_validated = false;
var auth_email = "";
var auth_password = "";

function is_validated(email, password) {
  if (email && password) {
    $("#authenticate_submit").prop("disabled", false);
  } else {
    $("#authenticate_submit").prop("disabled", true);
  }
}

jQuery(document).ready(function ($) {
  if ($("#form__update__password")) {
    $(document).on("input change", "#update-password", function (e) {
      password = e.target.value;
      $("#update-password").css(
        "borderColor",
        validation_succcess_border_color
      );
      switch (true) {
        case !password:
          update_password_validated = false;
          is_password_validated(
            update_confirm_password_validated,
            update_password_validated,
            password_validation_id
          );
          break;
        case password.length < 6:
          update_password_validated = false;
          is_password_validated(
            update_confirm_password_validated,
            update_password_validated,
            password_validation_id
          );
          break;
        default:
          update_password_validated = true;
          is_password_validated(
            update_confirm_password_validated,
            update_password_validated,
            password_validation_id
          );
      }
    });

    //detect confirm password changes to validate the input
    $(document).on("input change", "#update-confirm-password", function (e) {
      password_confirm = e.target.value;
      $("#update-confirm-password").css(
        "borderColor",
        validation_succcess_border_color
      );
      switch (true) {
        case !password_confirm:
          update_confirm_password_validated = false;
          break;

        case password_confirm.length < 6:
          update_confirm_password_validated = false;
          is_password_validated(
            update_confirm_password_validated,
            update_password_validated,
            password_validation_id
          );
          break;

        default:
          update_confirm_password_validated = true;
          is_password_validated(
            update_confirm_password_validated,
            update_password_validated,
            password_validation_id
          );
      }
    });

    $(document).on("submit", "#form__update__password", function (e) {
      e.preventDefault();
      if (password == password_confirm) {
        if (update_confirm_password_validated & update_password_validated) {
          $("#reset_submit").addClass("button--loading");
          update_password(password);
        }
      } else {
        $("#update-password").css(
          "borderColor",
          validation_failed_border_color
        );
        $("#update-confirm-password").css(
          "borderColor",
          validation_failed_border_color
        );
        $("#update-password-error").text(error_messages.confirm_password_match);
      }
    });
  }

  //!________________________________________________________ Re-Authentication _______________________________________

  //detect email changes to validate the input
  $(document).on("input focus", "#authenticate-email", function (e) {
    auth_email = e.target.value;

    if (auth_email.endsWith(" ") || auth_email.startsWith(" ")) {
      auth_email = auth_email.replace(" ", "");
    }

    switch (true) {
      case !auth_email:
        auth_email_validated = false;
        is_validated(auth_email_validated, auth_password_validated);
        break;
      case !email_regex.test(auth_email):
        auth_email_validated = false;
        is_validated(auth_email_validated, auth_password_validated);
        break;
      default:
        auth_email_validated = true;
        is_validated(auth_email_validated, auth_password_validated);
        break;
    }
  });

  //detect password changes to validate the input
  $(document).on("input focus", "#authenticate-password", function (e) {
    auth_password = e.target.value;
    switch (true) {
      case !auth_password || auth_password.length == 0:
        auth_password_validated = false;
        is_validated(auth_email_validated, auth_password_validated);
        break;

      default:
        auth_password_validated = true;
        is_validated(auth_email_validated, auth_password_validated);
    }
  });

  $(document).on("submit", "#form__authenticate", function (e) {
    e.preventDefault();

    if (auth_email_validated && auth_password_validated) {
      $("#authenticate_submit").addClass("button--loading");
      const firebaseAuth = loadFirebaseAuth();
      let user = firebaseAuth.currentUser;
      let credentials = EmailAuthProvider.credential(auth_email, auth_password);
      re_authenticate(user, credentials);
    }
  });
});

function re_authenticate(user, credentials) {
  reauthenticateWithCredential(user, credentials)
    .then((res) => {
      $("#popup-authenticate").remove();
      update_password(password);
    })
    .catch((error) => {
      catch_error(error);
      $("#authenticate_submit").removeClass("button--loading");
      if (
        error.message.includes(response_error_messages.auth_incorrect_email) ||
        error.message.includes(response_error_messages.invalid_password)
      ) {
        $("#authenticate-error").text(
          error_messages.auth_incorrect_email_or_password
        );
      }
    });
}
